var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignBoardIconPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6016 9.375H6.60156C6.30319 9.375 6.01705 9.49353 5.80607 9.7045C5.59509 9.91548 5.47656 10.2016 5.47656 10.5V37.5C5.47656 37.7984 5.59509 38.0845 5.80607 38.2955C6.01705 38.5065 6.30319 38.625 6.60156 38.625H42.6016C42.8999 38.625 43.1861 38.5065 43.3971 38.2955C43.608 38.0845 43.7266 37.7984 43.7266 37.5V10.5C43.7266 10.2016 43.608 9.91548 43.3971 9.7045C43.1861 9.49353 42.8999 9.375 42.6016 9.375ZM16.7266 27.375V20.625H32.4766V27.375H16.7266ZM7.72656 27.375V20.625H14.4766V27.375H7.72656ZM34.7266 20.625H41.4766V27.375H34.7266V20.625ZM41.4766 18.375H25.7266V11.625H41.4766V18.375ZM23.4766 11.625V18.375H7.72656V11.625H23.4766ZM7.72656 29.625H23.4766V36.375H7.72656V29.625ZM25.7266 36.375V29.625H41.4766V36.375H25.7266Z",
    fill: "#D22268"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignBoardIconPattern);
export default __webpack_public_path__ + "static/media/Design Board Icon Pattern.1a5f55b917ad572fb3d1bf0f2a5c10d6.svg";
export { ForwardRef as ReactComponent };